import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pt-10" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("临时启用账号")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确定")

import {  onMounted, reactive,ref } from 'vue'
import Api from '@/http/modules/index'
import message from '@/store/modules/message'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
    // 离职人员账户_分页查询
    'POST/account_reactivation/query':accountListsApi,
     // 用户下拉列表
     'GET/users/list': usersListApi,
    //  离职人员账户_启用
    'POST/account_reactivation/enable_account':enableAccountApi
}=Api
const tableHeight= window.innerHeight-200
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const accountLists=ref([])
const tableLoading=ref(false)
const getAccountLists=()=>{
    let {page,size}=pageInfo
    tableLoading.value=true
    accountListsApi({page,size}).then((res:any)=>{
        accountLists.value=res.data
        pageInfo.total=res.rowCount
    }).finally(()=>{
        tableLoading.value=false
    })
}
const reactivationVisiable=ref(false)
const optionloading=ref(false)
const userLists=ref([])
const userOptionLists=ref<any>([])
const reactivationInfo=ref<any>({
    validityDays:1
})
const enableAccountLoading=ref(false)
const reactivationFormRef=ref()
const remoteMethod=(query:any)=>{
    if (query) {
        optionloading.value = true
        setTimeout(() => {
            optionloading.value = false
            let resultArr:any=[]
            resultArr = userLists.value.filter((item:any) => {
                return item.realName.includes(query)||item.username.toLowerCase().includes(query.toLowerCase())
            })
            userOptionLists.value=resultArr.slice(0,20)
        }, 200)
    } else {
        userOptionLists.value = []
    }
}
const reactivateHandle=(formEl:any)=>{
    if (!formEl) return
  formEl.validate((valid:any) => {
    if (valid) {
        enableAccountLoading.value=true
        enableAccountApi(reactivationInfo.value).then(()=>{
            ElMessage.success('启用成功！随机密码发送至您的企业微信')
            reactivationVisiable.value=false
            getAccountLists()
        }).finally(()=>{
            enableAccountLoading.value=false
        })
    } 
  })  
}   
const resetForm=(formEl:any)=>{
    if (!formEl) return
    formEl.resetFields()
    reactivationInfo.value={
        validityDays:1
    }
}
onMounted(()=>{
    getAccountLists()
    usersListApi().then((res:any)=>{
        userLists.value=res
    })
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (reactivationVisiable.value=true))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_table, {
      data: accountLists.value,
      border: "",
      height: tableHeight+'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "启用人",
          prop: "enabledName",
          width: "150",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "启用时间",
          prop: "enabledTime",
          width: "170"
        }),
        _createVNode(_component_el_table_column, {
          label: "有效期（天）",
          width: "120",
          align: "right",
          prop: "validityDays"
        }),
        _createVNode(_component_el_table_column, {
          label: "启用原因",
          prop: "enableReason",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "username",
          width: "150",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "orgNames",
          width: "180",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "companyName",
          width: "180",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "部门",
          prop: "departmentName",
          width: "140",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "账号状态",
          prop: "canLogin",
          width: "100"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_tag, {
              type: row.canLogin?'success':'danger'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.canLogin?'可登录':'不可登录'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "人员状态",
          prop: "staffType",
          width: "100"
        })
      ]),
      _: 1
    }, 8, ["data", "height"]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(pageInfo).total,
      "page-size": _unref(pageInfo).size,
      currentPage: _unref(pageInfo).page,
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      class: "mb-5 mt-5",
      "page-sizes": [30, 60, 90, 120],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _cache[2] || (_cache[2] = ()=>getAccountLists()),
      onSizeChange: _cache[3] || (_cache[3] = ()=>getAccountLists())
    }, null, 8, ["total", "page-size", "currentPage"]),
    _createVNode(_component_el_dialog, {
      onClose: _cache[9] || (_cache[9] = ($event: any) => (resetForm(reactivationFormRef.value))),
      modelValue: reactivationVisiable.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((reactivationVisiable).value = $event)),
      title: "临时启用账号",
      width: "500"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: enableAccountLoading.value,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (reactivationVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          loading: enableAccountLoading.value,
          type: "primary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (reactivateHandle(reactivationFormRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: reactivationInfo.value,
          "label-width": "100",
          ref_key: "reactivationFormRef",
          ref: reactivationFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "姓名:",
              prop: "userId",
              rules: [{required:true,message:'请选择临时启用账号'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  loading: optionloading.value,
                  filterable: "",
                  modelValue: reactivationInfo.value.userId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((reactivationInfo.value.userId) = $event)),
                  remote: "",
                  "remote-method": remoteMethod,
                  "reserve-keyword": "",
                  clearable: "",
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userOptionLists.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.userId,
                        value: item.userId,
                        label: `${item.realName} (${item.username })`
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "有效期:",
              prop: "validityDays",
              rules: [{required:true,message:'请选择有效期'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: reactivationInfo.value.validityDays,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((reactivationInfo.value.validityDays) = $event)),
                  min: 1,
                  max: 7,
                  "step-strictly": "",
                  step: 1
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "启用原因:",
              prop: "enableReason",
              rules: [{required:true,message:'请输入启用原因'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: reactivationInfo.value.enableReason,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((reactivationInfo.value.enableReason) = $event)),
                  autosize: { minRows: 4 },
                  type: "textarea",
                  placeholder: "请输入启用原因"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})